<template>
  <router-view/>
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#27ad95',
      },
    }"
  >
  
  </a-config-provider>
</template>
<script setup>
import { onBeforeUnmount, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { AUTH_EXPIRED_EVENT } from '@/utils/auth';

let authExpiredMessageTimer = null;

const handleAuthExpired = () => {
  if (authExpiredMessageTimer) {
    return;
  }

  message.warning('登录状态已失效，请重新登录');
  authExpiredMessageTimer = setTimeout(() => {
    authExpiredMessageTimer = null;
  }, 1500);
};

onMounted(() => {
  window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
});

onBeforeUnmount(() => {
  window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
  if (authExpiredMessageTimer) {
    clearTimeout(authExpiredMessageTimer);
  }
});
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
